export const styles = {
  helperText: {
    "@media (max-width: 900px)": {
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
  },
};
